import React, { useEffect, useState } from 'react'
import { Logo } from '../components/logo'
import menuIcon from '../assets/icons/menu.svg';
import { useAppContext } from '../context/appContext';
import { TextLg, TextMd, TextSm } from '../components/text';

export const TopBar = ({ className="", style={} }) => {
  const { loading, loadingTime, setMenuOpen, setLoading, routing } = useAppContext();
  const { navigate, url, baseUrl } = routing;
  const fastLoad = ()=> setTimeout(()=> setLoading(false),loadingTime / 2);

  return ( 
    <div
      className={`
        absolute top-0 left-0 right-0
        z-[15] h-16 flex items-center
        select-none p-1
        ${className}
      `}
      style={style}
    >
      <TextMd className='mr-auto h-full flex items-center'>
        <Logo 
          className={`px-6`}
          onClick={()=>{
            navigate(baseUrl);
          }} 
        />
      </TextMd>
      
      <TextSm className='hidden lg:flex h-full w-2/3 text-gray-100 *:w-full *:grid *:place-items-center font-bold'>
        <NavLink path="/data-analytics">Data Analytics</NavLink>
        {/* <NavLink path="/automation">Automation</NavLink> */}
        <NavLink path="/web-development">Web Development</NavLink>
        <NavLink path="/contact">Contact</NavLink>
      </TextSm>

      <button 
        className='h-full px-6'
        onClick={()=>{
          setMenuOpen(true);          
        }}
      >
        <img className='h-8 white-svg' src={menuIcon} />
      </button>
    </div>
  )
}

export const NavLink = ({ path, className="", onClick, ...rest })=>{
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`h-full ${className}`}
      onClick={()=>{
        navigate(path);
        onClick?.();
      }}
      {
        ...rest
      }
    />
  )
}